import React from 'react';
import { getStepProgress } from '../../data/journeys/journeyProgress';

function StepStatusDot({ status, isActive }) {
	if (status === 'complete') {
		return <span className="guided-journey__step-dot guided-journey__step-dot--complete" aria-hidden="true">✓</span>;
	}
	if (isActive) {
		return <span className="guided-journey__step-dot guided-journey__step-dot--current" aria-hidden="true" />;
	}
	if (status === 'in_progress') {
		return <span className="guided-journey__step-dot guided-journey__step-dot--progress" aria-hidden="true" />;
	}
	return <span className="guided-journey__step-dot" aria-hidden="true" />;
}

function JourneyDashboard({ journey, progress, activeStepId, onSelectStep, overallPercent, compact }) {
	return (
		<aside className={`guided-journey__dashboard${compact ? ' guided-journey__dashboard--compact' : ''}`}>
			{!compact && (
				<div className="guided-journey__dashboard-header">
					<h2 className="guided-journey__dashboard-title">Step checklist</h2>
					<p className="guided-journey__dashboard-sub">Optional — jump between planning steps</p>
				</div>
			)}
			<div className="guided-journey__overall">
					<div className="guided-journey__overall-bar" role="progressbar" aria-valuenow={overallPercent} aria-valuemin="0" aria-valuemax="100">
						<div className="guided-journey__overall-fill" style={{ width: `${overallPercent}%` }} />
					</div>
					<span className="guided-journey__overall-label">{overallPercent}% prepared</span>
				</div>

			<ol className="guided-journey__step-list">
				{journey.steps.map((step, i) => {
					const { status, label, fraction } = getStepProgress(step, progress, journey);
					const isActive = activeStepId === step.id;
					return (
						<li
							key={step.id}
							className={`guided-journey__step-li is-${status}${isActive ? ' is-current' : ''}`}
						>
							<div className="guided-journey__step-rail" aria-hidden="true">
								<StepStatusDot status={status} isActive={isActive} />
								{i < journey.steps.length - 1 && <span className="guided-journey__step-line" />}
							</div>
							<button
								type="button"
								className="guided-journey__step-btn"
								onClick={() => onSelectStep(step.id)}
								aria-current={isActive ? 'step' : undefined}
							>
								<span className="guided-journey__step-meta">
									<span className="guided-journey__step-num">Step {i + 1}</span>
									{isActive && <span className="guided-journey__step-here">You are here</span>}
								</span>
								<span className="guided-journey__step-name">{step.icon} {step.name}</span>
								<span className={`guided-journey__step-badge guided-journey__step-badge--${status}`}>
									{label}
								</span>
								{fraction > 0 && fraction < 1 && (
									<span className="guided-journey__step-mini-bar" aria-hidden="true">
										<span style={{ width: `${fraction * 100}%` }} />
									</span>
								)}
							</button>
						</li>
					);
				})}
			</ol>
		</aside>
	);
}

export default JourneyDashboard;
